import { OrderSource } from 'src/entities/Order';
import { formatNumber, formatPrice } from 'src/services/utils';

const OrderResume = ({
  discounts,
  estimatedShippingCost,
  estimatedTaxes,
  netValue,
  shippingCostInventa,
  source,
  takeRate,
  takeRateValue,
  totalPrice,
  totalTaxes,
  fees,
}) => {
  const isInventaSalesSource = [
    OrderSource.VENDORS_PORTAL,
    OrderSource.SALES_APP,
  ].includes(source);

  const processingFee = fees?.reduce((acc, fee) => acc + fee.value, 0);

  return (
    <div className="col-12 col-md-12 col-xl-4 d-flex align-items-start gap-3 mt-4">
      <i className="far fa-calendar-alt text-muted mt-1" />
      <div>
        <p className="fw-bold text-muted mb-2">RESUMO DO PEDIDO</p>
        <div className="lh-base text-secondary">
          <p className="mb-0">{`${formatPrice(
            totalPrice,
          )} - Total dos Produtos`}</p>
          {isInventaSalesSource ? (
            <>
              <p className="mb-0 text-success">
                {`(+) ${formatPrice(estimatedTaxes)} - Impostos`}
              </p>

              <p className="mb-0 text-success">
                {`(+) ${formatPrice(estimatedShippingCost)} - Valor de Envio`}
              </p>
            </>
          ) : (
            <>
              <p className="mb-0 text-success">
                {`(+) ${formatPrice(totalTaxes)} - Impostos`}
              </p>
              {shippingCostInventa !== null ? (
                <p className="mb-0 text-success">
                  {`(+) ${formatPrice(shippingCostInventa)} - Valor de Envio`}
                </p>
              ) : (
                ''
              )}
            </>
          )}
          <p className="mb-0 text-danger">
            {`(-) ${formatPrice(discounts || 0)} - Desconto`}
          </p>
          {isInventaSalesSource && (
            <p className="mb-0 border-t-1 mb-2 text-dark fw-bold">
              {`${formatPrice(
                totalPrice + estimatedTaxes + estimatedShippingCost - discounts,
              )} - Total pago pelo lojista`}
            </p>
          )}
          <p className="mb-0 text-danger">
            {`(-) ${formatPrice(takeRateValue)} - Comissão (${formatNumber(
              takeRate,
            )}%)`}
          </p>
          {!!processingFee && (
            <p className="mb-0 text-danger">
              {`(-) ${formatPrice(processingFee)} - Taxa de processamento`}
            </p>
          )}
          <p className="mb-0 text-dark border-t-1 fw-bold">
            {`${formatPrice(netValue)} - Repasse`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderResume;
